export * from 'yoda-site-components/lib/actionTypes/IrisActionTypes';
export * from './HomePageActionTypes';
export * from './DepartmentPageActionTypes';

// Default export for bootstrap.js compatibility
const actionTypes = {};
export default actionTypes;
